import { addLabelArray } from "helpers/addLabelArray";
import { idGenerator } from "helpers/createId";
import { formatCustomDate } from "helpers/dateTools";
import { persistLocalStorage } from "helpers/localstorageTool";
import { orderArrayV2 } from "helpers/orderArray";
import { routesStatus } from "helpers/timeStatus";
import {
  processNotes,
  setSettlement,
  editSettlementNote,
  changeSettlementStartRouteEndowments,
  changeSettlementEndRouteEndowments,
  addSettlementNewNote,
  removeSettlementNote,
} from "./reducerCases";

import { ActionTypes } from "./types";

const {
  FILTER_ROUTES_INPUTS,
  REQUEST_DATA,
  FILTER_ROUTES,
  GET_DATA,
  GET_SETTLEMENT_DISPENSERS,
  GET_SETTLEMENT_PRODUCTS,
  GET_SETTLEMENT_PAYMENTS,
  GET_SETTLEMENT_ACCOUNT_DETAILS,
  SET_ERROR,
  CHANGE_STATION_ROUTES,
  CHANGE_UNIT_TYPE,
  CHANGE_START_DATE,
  CHANGE_END_DATE,
  CLEAR_ERROR,
  SET_ROUTE,
  SET_CONFIG_PAGE,
  SET_CONFIG_PAGE_SIZE,
  SET_CONFIG_FILTER,
  SET_CONFIG_SORTED,
  REQUEST_ENDOWMENTS,
  SET_ENDOWMENTS,
  EDIT_ENDOWMENT,
  REQUEST_ENDOWMENT,
  GET_ENDOWMENT,
  REQUEST_SETTLEMENT,
  SET_SETTLEMENT,
  RESET_SETTLEMENT,
  EDIT_SETTLEMENT,
  SELECT_NOTE,
  EDIT_SETTLEMENT_NOTE,
  SET_NOTES_MODAL,
  REMOVE_SETTLEMENT_NOTE,
  REQUEST_CUSTOMER,
  SET_CUSTOMER_ROUTE,
  SET_ROUTES_SNACKBAR,
  RESET_ROUTES_SNACKBAR,
  SET_TICKET_TO_PRINT,
  SET_UNIT_INFORMATION,
  CHANGE_SETTLEMENT_DISPENSER,
  CHANGE_SETTLEMENT_START_ROUTE_ENDOWMENTS,
  CHANGE_SETTLEMENT_END_ROUTE_ENDOWMENTS,
  CHANGE_SETTLEMENT_LTS,
  CHANGE_SETTLEMENT_PERCENTAGE,
  SET_SETTLEMENT_NEW_NOTE,
  SELECT_SETTLEMENT_NEW_NOTE_DETAIL,
  EDIT_SETTLEMENT_NEW_NOTE_DETAIL,
  DELETE_SETTLEMENT_NEW_NOTE_DETAIL,
  SET_SETTLEMENT_NEW_NOTE_DETAIL,
  ADD_SETTLEMENT_NEW_NOTE,
  CLEAN_ROUTES_BY_TYPE,
  SETTLEMENT_TOTAL_REPORT,
  SET_PIN,
  SET_AUTO_MODE,
  SET_CAUSES,
  SET_DEL_CAUSE,
  IS_NEW_NOTE,
  REMOVE_ALL_NOTES,
  REMOVE_ROUTE_SHARE,
  UPDATE_NOTE_ACC,
  ASSIGN_SGC,
  UPDATE_NOTE_FOLIO,
  SET_TRANSFER_INVOICE_TOKEN,
} = ActionTypes;

const { OPEN, NO_STATUS, CLOSED } = routesStatus;

const initialState = {
  routes: [],
  stations: [],
  products: [],
  payments: [],
  accountDetails: {},
  endowmentsLoading: false,
  endowments: {},
  endowmentsArr: [],
  endowment: null,
  endowmentLoading: false,
  settlementLoading: false,
  settlement: {},
  customer: {},
  customerLoading: false,
  noteSelected: null,
  detailSelected: null,
  isLoading: false,
  color: "danger",
  error: false,
  message: "",
  errorMessage: "",
  startDate: formatCustomDate(new Date(), "-"),
  endDate: formatCustomDate(new Date(), "-"),
  station: null,
  unit: null,
  nameStation: "",
  selected: null,
  snackbar: {
    isActive: false,
    message: "",
    color: "",
  },
  modalNote: false,
  temp: {
    OPEN: [],
    CLOSED: [],
    NO_STATUS: [],
  },
  status: {
    OPEN: true,
    CLOSED: true,
    NO_STATUS: true,
  },
  config: {
    page: 0,
    pageSize: 20,
    filtered: [],
    sorted: [],
  },
  configNotes: {
    page: 0,
    pageSize: 20,
    filtered: [],
    sorted: [],
  },
  urlTicketToPrint: "",
  isPinned: false,
  pinned: [],
  autoMode: false,
  isNewNote: false,
  blackListFolio: [],
  isDeleteNote: false,
};

export const splitStatusRoutes = (data) => {
  const routes = {
    [OPEN.value]: [],
    [NO_STATUS.value]: [],
    [CLOSED.value]: [],
  };

  data.forEach((route) => {
    if (Object.prototype.hasOwnProperty.call(routes, route.status)) {
      routes[route.status].push(route);
    } else {
      routes[route.status] = [route];
    }
  });

  return routes;
};

export const getCilEndowment = (insert) => {
  let entries = Object.entries(insert.endowments);

  const result = entries.reduce((acc, curr) => {
    const cil = parseInt(curr[0].split("cil")[1]) || 0;
    return acc + cil * (curr[1] || 0);
  }, 0);

  return parseInt(result);
};

export const routesStatusReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FILTER_ROUTES_INPUTS:
      let routesState = state.routes;

      if (payload.key === "station" || payload.key === "unit") routesState = [];
      return {
        ...state,
        [payload.key]: payload.value,
        routes: routesState,
      };

    case CLEAN_ROUTES_BY_TYPE:
      return {
        ...state,
        routes: [],
      };
    case FILTER_ROUTES:
      const newStatus = { ...state.status };
      newStatus[payload] = !newStatus[payload];
      const open = newStatus.OPEN ? state.temp.OPEN : [];
      const no_status = newStatus.NO_STATUS ? state.temp.NO_STATUS : [];
      const closed = newStatus.CLOSED ? state.temp.CLOSED : [];
      const fRoutes = [...open, ...no_status, ...closed];
      return {
        ...state,
        status: newStatus,
        routes: fRoutes,
        config: {
          ...state.config,
          page: 0,
        },
        isPinned: false,
        pinned: [],
      };
    case GET_SETTLEMENT_PRODUCTS:
      return {
        ...state,
        products: orderArrayV2(payload, "name"),
      };
    case GET_SETTLEMENT_PAYMENTS:
      const paymentsLabel = addLabelArray(payload, "name");
      return {
        ...state,
        payments: paymentsLabel,
      };
    case GET_SETTLEMENT_ACCOUNT_DETAILS:
      return {
        ...state,
        accountDetails: payload,
      };
    case REQUEST_DATA:
      return {
        ...state,
        stations: [],
        isLoading: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case GET_DATA:
      const newRoutes = payload.map((route) => {
        return {
          ...route,
          statusEsp: routesStatus[route.status].translate,
          startDate: route.start,
          endDate: route.end,
          color: routesStatus[route.status].color,
          bgColor: routesStatus[route.status].bgColor,
          tempStartId: idGenerator(),
          tempEndId: idGenerator(),
        };
      });
      const sortNewPayload = orderArrayV2(newRoutes, "startDate", true);
      const routes = splitStatusRoutes(sortNewPayload);
      return {
        ...state,
        routes: sortNewPayload,
        routesOriginal: sortNewPayload,
        temp: routes,
        status: {
          ...initialState.status,
        },
        config: {
          ...state.config,
          page: 0,
        },
        isLoading: false,
        isPinned: false,
        pinned: [],
      };
    case CHANGE_STATION_ROUTES:
      return {
        ...state,
        station: payload,
      };

    case CHANGE_UNIT_TYPE:
      return {
        ...state,
        unit: payload,
      };
    case CHANGE_START_DATE:
      return {
        ...state,
        startDate: payload,
      };
    case CHANGE_END_DATE:
      return {
        ...state,
        endDate: payload,
      };
    case SET_ROUTE:
      return {
        ...state,
        selected: payload,
      };
    case REQUEST_ENDOWMENTS:
      return {
        ...state,
        endowmentsLoading: true,
      };
    case SET_ENDOWMENTS:
      const nRoutesO = state.routesOriginal.filter(
        (rt) => rt.route !== payload.idUnit,
      );
      return {
        ...state,
        routes: nRoutesO,
        temp: splitStatusRoutes(nRoutesO),
        status: {
          ...initialState.status,
        },
        endowmentsLoading: false,
      };

    case REQUEST_ENDOWMENT:
      return {
        ...state,
        endowmentLoading: true,
      };

    case GET_ENDOWMENT:
      return {
        ...state,
        endowmentLoading: false,
        endowment: payload,
      };
    case EDIT_ENDOWMENT:
      return {
        ...state,
        endowmentsLoading: false,
        endowments: {
          ...state.endowments,
          [payload.idUnit]: payload,
        },
      };
    case REQUEST_SETTLEMENT:
      return {
        ...state,
        settlementLoading: true,
      };
    case SET_SETTLEMENT:
      return setSettlement(state, payload);
    case SELECT_NOTE:
      return {
        ...state,
        noteSelected: state.settlement.notes.find(
          (note) => note.id === payload,
        ),
      };

    case REQUEST_CUSTOMER:
      return {
        ...state,
        customerLoading: true,
      };

    case SET_CUSTOMER_ROUTE:
      return {
        ...state,
        customerLoading: false,
        customer: payload,
      };
    case RESET_SETTLEMENT:
      return {
        ...state,
        settlement: {},
        configNotes: {
          ...initialState.configNotes,
        },
      };
    case EDIT_SETTLEMENT:
      return {
        ...state,
        settlementLoading: false,
        settlement: payload,
      };

    case SET_NOTES_MODAL:
      return {
        ...state,
        modalNote: !state.modalNote,
      };

    case EDIT_SETTLEMENT_NOTE:
      return editSettlementNote(state, payload);

    //MANUAL SETTLEMENT
    case SET_UNIT_INFORMATION:
      return {
        ...state,
        settlement: {
          ...state.settlement,
          unit: payload,
        },
      };

    case SET_SETTLEMENT_NEW_NOTE:
      const baseNote = { idTemp: payload, new: true, details: [] };

      return {
        ...state,
        noteSelected: baseNote,
        settlement: {
          ...state.settlement,
          notes: processNotes([...state.settlement.notes, baseNote]),
          services: state.settlement?.services + 1,
        },
      };

    case EDIT_SETTLEMENT_NEW_NOTE_DETAIL:
      const oldNoteIdx = state.settlement.notes.findIndex(
        (note) =>
          note?.id === payload.idNote || note?.idTemp === payload.idNote,
      );
      const oldNoteDetailIdx = state.settlement.notes[
        oldNoteIdx
      ]?.details.findIndex((detail) => detail.id === payload.idDetail);

      if (oldNoteIdx === -1 || oldNoteDetailIdx === -1) return state;

      const editedNotes = state.settlement.notes;
      const newDetails = editedNotes[oldNoteIdx].details;
      const newDetail = editedNotes[oldNoteIdx].details[oldNoteDetailIdx];

      newDetails[oldNoteDetailIdx] = {
        ...newDetail,
        ...payload.body,
      };

      editedNotes[oldNoteIdx] = {
        ...editedNotes[oldNoteIdx],
        details: newDetails,
      };

      return {
        ...state,
        detailSelected: null,
        noteSelected: editedNotes[oldNoteIdx],
        settlement: {
          ...state.settlement,
          notes: processNotes(editedNotes),
        },
      };

    case DELETE_SETTLEMENT_NEW_NOTE_DETAIL:
      const deleteNoteIdx = state.settlement.notes.findIndex(
        (note) =>
          note?.id === payload.idNote || note?.idTemp === payload.idNote,
      );
      const deleteNoteDetailIdx = state.settlement.notes
        .find((note) => note.id === payload.idNote)
        ?.details.findIndex((detail) => detail.id === payload.idDetail);

      if (deleteNoteIdx === -1 || deleteNoteDetailIdx === -1) return state;

      const editedDeletedNotes = state.settlement.notes;

      const editedDetails = editedDeletedNotes[deleteNoteIdx].details.filter(
        (detail) => detail.id !== payload.idDetail,
      );

      editedDeletedNotes[deleteNoteIdx] = {
        ...editedDeletedNotes[deleteNoteIdx],
        details: editedDetails,
      };

      return {
        ...state,
        detailSelected: null,
        noteSelected: editedDeletedNotes[deleteNoteIdx],
        settlement: {
          ...state.settlement,
          notes: processNotes(editedDeletedNotes),
        },
      };

    case SELECT_SETTLEMENT_NEW_NOTE_DETAIL:
      const newNoteState = state.settlement.notes.find(
        (note) =>
          note?.id === payload.idNote || note?.idTemp === payload.idNote,
      );
      const detailSelected = newNoteState.details.find(
        (detail) => detail.id === payload.idDetail,
      );
      return {
        ...state,
        detailSelected: detailSelected,
      };

    case SET_SETTLEMENT_NEW_NOTE_DETAIL:
      const newNoteDetailState = state.settlement.notes.find(
        (note) => note.id === payload.idNote || note?.idTemp === payload.idNote,
      );
      const restNotes = state.settlement.notes.filter(
        (note) =>
          !(note?.id === payload.idNote || note?.idTemp === payload.idNote),
      );
      const newBaseNote = {
        ...newNoteDetailState,
        details: [...newNoteDetailState.details, payload.detail],
      };

      return {
        ...state,
        detailSelected: null,
        noteSelected: newBaseNote,
        settlement: {
          ...state.settlement,
          notes: processNotes([...restNotes, newBaseNote]),
        },
      };

    case GET_SETTLEMENT_DISPENSERS:
      return {
        ...state,
        settlement: {
          ...state.settlement,
          dispenser: payload.find(
            (obj) => obj.id === state?.settlement?.dispenser?.id,
          ),
          unit: {
            ...state.settlement.unit,
            dispensers: payload,
          },
        },
      };

    case CHANGE_SETTLEMENT_DISPENSER:
      return {
        ...state,
        settlement: {
          ...state.settlement,
          dispenser: payload,
        },
      };

    case SETTLEMENT_TOTAL_REPORT:
      const limit = payload < 0 ? 0 : payload;

      return {
        ...state,
        settlement: {
          ...state.settlement,
          totalReport: parseFloat(limit.toFixed(2)),
        },
      };
    case CHANGE_SETTLEMENT_START_ROUTE_ENDOWMENTS:
      return changeSettlementStartRouteEndowments(state, payload);

    case CHANGE_SETTLEMENT_END_ROUTE_ENDOWMENTS:
      return changeSettlementEndRouteEndowments(state, payload);

    case CHANGE_SETTLEMENT_LTS:
      if (payload.value < 0) return state;
      const { key, value, routeType } = payload;
      const finalLts = {
        ...state.settlement.routes[routeType],
        endowments: {
          ...state.settlement.routes[routeType].endowments,
          [key]: value,
        },
      };

      const result =
        finalLts.endowments.flowmeter -
        state.settlement.routes.start.endowments.flowmeter;
      return {
        ...state,
        settlement: {
          ...state.settlement,
          routes: {
            ...state.settlement.routes,
            [routeType]: finalLts,
          },
          totalReport: result < 0 ? 0 : parseFloat(result.toFixed(2)),
        },
      };

    case CHANGE_SETTLEMENT_PERCENTAGE:
      if (payload.value < 0) return state;
      const finalPercentage = {
        ...state.settlement.routes[payload.routeType],
        endowments: {
          ...state.settlement.routes[payload.routeType].endowments,
          [payload.key]: payload.value,
        },
      };
      return {
        ...state,
        settlement: {
          ...state.settlement,
          routes: {
            ...state.settlement.routes,
            [payload.routeType]: finalPercentage,
          },
        },
      };

    case ADD_SETTLEMENT_NEW_NOTE:
      return addSettlementNewNote(state, payload);

    case REMOVE_SETTLEMENT_NOTE:
      return removeSettlementNote(state, payload);

    case SET_CONFIG_FILTER:
      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          filtered: payload.value,
          page: 0,
        },
      };
    case SET_CONFIG_PAGE:
      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          page: payload.value,
        },
      };
    case SET_CONFIG_PAGE_SIZE:
      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          pageSize: payload.value,
          page: 0,
        },
      };
    case SET_CONFIG_SORTED:
      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          sorted: payload.value,
          page: 0,
        },
      };
    case CLEAR_ERROR:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    case SET_ERROR:
      return {
        ...state,
        color: "danger",
        error: true,
        errorMessage: payload,
      };

    case SET_ROUTES_SNACKBAR:
      return {
        ...state,
        snackbar: {
          isActive: true,
          message: payload.message,
          color: payload.color,
        },
      };

    case RESET_ROUTES_SNACKBAR:
      return {
        ...state,
        isLoading: false,
        customerLoading: false,
        settlementLoading: false,
        snackbar: {
          isActive: false,
          message: "",
          color: "",
        },
      };

    case SET_TICKET_TO_PRINT:
      return {
        ...state,
        urlTicketToPrint: payload,
      };

    case ASSIGN_SGC:
      return {
        ...state,
        settlement: {
          ...state.settlement,
          fillingOrder: payload,
        },
      };

    case SET_PIN:
      const isPinned = !state.isPinned;
      return {
        ...state,
        isPinned: isPinned,
        pinned: isPinned ? [payload] : [],
      };
    case SET_AUTO_MODE:
      return {
        ...state,
        autoMode: !state.autoMode,
      };
    case SET_CAUSES:
      return {
        ...state,
        causes: addLabelArray(payload, "cause"),
      };
    case SET_DEL_CAUSE:
      let notesDeleted = [...state.settlement.notes];

      const idxNote = notesDeleted.findIndex(
        (note) => note.id === payload.noteID,
      );
      let noteToRemove = notesDeleted[idxNote];
      noteToRemove = {
        ...noteToRemove,
        deletedCauseId: payload.causeID,
        deleted: payload.causeID !== null ? true : false,
      };

      return {
        ...state,
        settlement: {
          ...state.settlement,
          notes: notesDeleted,
          cashAmount: noteToRemove.type.includes("CONTADO")
            ? state.settlement.cashAmount - noteToRemove.total
            : state.settlement.cashAmount,
          creditAmount: noteToRemove.type.includes("CREDITO")
            ? state.settlement.creditAmount - noteToRemove.total
            : state.settlement.creditAmount,
        },
      };

    case IS_NEW_NOTE:
      return {
        ...state,
        isNewNote: !state.isNewNote,
      };

    case REMOVE_ALL_NOTES:
      return {
        ...state,
        settlement: {
          ...state.settlement,
          notes: [],
        },
      };

    case REMOVE_ROUTE_SHARE:
      const routeRemoved = [...state.routes];
      persistLocalStorage("route-share", { isSharing: false, route: null });
      return {
        ...state,
        routes: routeRemoved.filter((route) => route.route !== payload),
      };
    case UPDATE_NOTE_ACC:
      return {
        ...state,
        settlement: {
          ...state.settlement,
          notes: state.settlement.notes.map((note) =>
            note.id === payload.noteId
              ? {
                  ...note,
                  idAccount: payload.idAccount,
                  accountName: payload.accountName,
                  accountCode: payload.accountCode,
                }
              : note,
          ),
        },
      };
    case UPDATE_NOTE_FOLIO:
      return {
        ...state,
        settlement: {
          ...state.settlement,
          notes: state.settlement.notes.map((note) =>
            note.id === payload.noteId
              ? { ...note, folio: payload.newFolio }
              : note,
          ),
        },
      };
    case SET_TRANSFER_INVOICE_TOKEN: {
      // Marca la ruta OPEN de la unidad como facturada para que el botón
      // deje de ofrecer "Generar" (evita doble Carta Porte). Si el POST no
      // trae token se conserva el actual y solo se marca como generada.
      const markGenerated = (list = []) =>
        list.map((route) =>
          route.route === payload.idUnit && route.status === OPEN.value
            ? {
                ...route,
                transferInvoicePdfToken:
                  payload.token || route.transferInvoicePdfToken,
                transferInvoiceGenerated: true,
              }
            : route,
        );
      return {
        ...state,
        routes: markGenerated(state.routes),
        routesOriginal: markGenerated(state.routesOriginal),
        pinned: markGenerated(state.pinned),
        temp: state.temp?.[OPEN.value]
          ? { ...state.temp, [OPEN.value]: markGenerated(state.temp[OPEN.value]) }
          : state.temp,
      };
    }
    default:
      return state;
  }
};
